import React, { useRef } from 'react';
import '../App.css';

import HomeFurniture from "../Components/HomeFurniture";
import HeroSection from "../Components/Hero-Section";
import AboutUs from "../Components/AboutUs";
import PergolasAndDecks from "../Components/PergolasAndDecks";
import GardenFurniture from "../Components/GardenFurniture";
import ContactUs from "./ContactUs";
import Offers from "../Components/Offers";
import OurProjects from "../Components/OurProjects";
import BgPic2 from "../Components/Backgrounds/BgPic2";
import BgPic1 from "../Components/Backgrounds/BgPic1";

function Home() {
    // הגדרת כל הרפרנסים לניווט בגלילה מה-Hero
    const PergolasAndDecksRef = useRef(null);
    const cardsRef = useRef(null);
    const middelRef = useRef(null);
    const mainRef = useRef(null);
    const supplierRef = useRef(null);
    const specialOffersRef = useRef(null);
    const contactUsRef = useRef(null);
    const ourProjects = useRef(null);

    // פונקציית הגלילה המקורית שלך - הוספתי לה קצת הגנות כדי למנוע קריסה
    const scrollToSection = (ref) => {
        if (ref && ref.current) {
            // yOffset קל כדי שה-Navbar הבהיר לא יסתיר את הכותרת כשאנחנו גוללים
            const yOffset = -90;
            const y = ref.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <div className="bg-background min-h-screen">

            {/* מסך הפתיחה: הגריד (Bento Box) ושורת החיפוש */}
            <HeroSection
                scrollToSection={scrollToSection}
                PergolasAndDecksRef={PergolasAndDecksRef}
                cardsRef={cardsRef}
                middelRef={middelRef}
                ourProjects={ourProjects}
            />

            {/* המשך האתר: כאן יישמנו ריווח מאסיבי (space-y-24 עד space-y-32) כדי לייצר תחושה של קטלוג מאוורר */}
            <div className="flex flex-col space-y-24 md:space-y-32 pb-32 pt-20">
                <section ref={specialOffersRef}>
                    <AboutUs/>
                </section>

                <section ref={PergolasAndDecksRef}>
                    <PergolasAndDecks/>
                </section>

                <section ref={mainRef}>
                    <BgPic2/>
                </section>

                <section ref={cardsRef}>
                    <HomeFurniture/>
                </section>

                <section ref={supplierRef}>
                    <BgPic1/>
                </section>

                <section ref={middelRef}>
                    <GardenFurniture/>
                </section>

                <Offers/>

                <section ref={ourProjects}>
                    <OurProjects/>
                </section>

                <section ref={contactUsRef}>
                    <ContactUs/>
                </section>
            </div>

        </div>
    );
}

export default Home;